export interface ReportTypeItem {
    report: string
    id: string
    labelFieldName: string
    printed: string
    confirmationMessage: string
    confirmationCheckMessage: string
    nameModal: string
}

export interface ReportType {
    [key: string]: ReportTypeItem
}

export const reportType: ReportType = {
    GRID_REPORT: {
        report: 'GRID_REPORT',
        id: '',
        labelFieldName: '',
        printed: '',
        confirmationMessage: '',
        confirmationCheckMessage: '',
        nameModal: ''
    },
    REQUEST_REPORT: {
        report: 'REPORTS',
        id: 'id',
        labelFieldName: 'label',
        printed: 'reqPrinted',
        confirmationMessage: 'print.modals.requestPrinted',
        confirmationCheckMessage: 'print.modals.printedCheck',
        nameModal: ''
    },
    SUBREQUEST_LABEL: {
        report: 'SUBREQUEST_LABEL',
        id: 'id',
        labelFieldName: 'surExternalId',
        printed: 'surPrinted',
        confirmationMessage: 'print.modals.subrequestPrinted',
        confirmationCheckMessage: 'print.modals.printedCheck',
        nameModal: 'printSampleLabelConfirmationClinical'
    },
    CASE_REPORT: {
        report: 'REPORTS',
        id: 'casId',
        labelFieldName: 'casExternalId',
        printed: '',
        confirmationMessage: 'print.modals.casePrinted',
        confirmationCheckMessage: 'print.modals.printedCheck',
        nameModal: ''
    },
    CASE_LABEL: {
        report: 'CASE_LABEL',
        id: 'casId',
        labelFieldName: 'casCasenumber',
        printed: 'casPrinted',
        confirmationMessage: 'print.modals.caseLabelPrinted',
        confirmationCheckMessage: 'print.modals.printedCheck',
        nameModal: 'printCaseLabelConfirmation'
    },
    SAMPLE_LABEL: {
        report: 'SAMPLE_LABEL',
        id: 'id',
        labelFieldName: 'label',
        printed: 'printed',
        confirmationMessage: 'print.modals.samplePrinted',
        confirmationCheckMessage: 'print.modals.printedCheck',
        nameModal: 'printSampleLabelConfirmationRegistry'
    },
    INCIDENT_REPORT: {
        report: 'REPORTS',
        id: 'incId',
        labelFieldName: 'incExternalId',
        printed: '',
        confirmationMessage: 'print.modals.incidentPrinted',
        confirmationCheckMessage: 'print.modals.printedCheck',
        nameModal: ''
    },
    CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL: {
        report: 'CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL',
        id: 'porId',
        labelFieldName: 'label',
        printed: 'printLabelDate',
        confirmationMessage: 'print.modals.cassettePortionsPrinted',
        confirmationCheckMessage: 'print.modals.printedCheck',
        nameModal: 'printCassetePortionsModalState'
    },
    SUBPORTION_LABEL: {
        report: 'SUBPORTION_SLIDE_LABEL',
        id: 'supId',
        labelFieldName: 'label',
        printed: 'printed',
        confirmationMessage: 'print.modals.subportionPrinted',
        confirmationCheckMessage: 'print.modals.printedCheck',
        nameModal: 'printSubportionModalState'
    }
}
export const PRINTMATE_CASSETTE_LABEL_REPORT_MODEL = 'PRINTMATE_CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL'
export const CASSETTE_LABEL_REPORT_MODELS = [
    PRINTMATE_CASSETTE_LABEL_REPORT_MODEL,
    reportType.CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL.report
]
